import './_SiteLocaleSelectionPopupMenu.scss';

import React from 'react';
import SiteLocaleSelectionPopupMenu from '@progymedia/gatsby-theme-boutik-ecommerce/src/components/SiteLocale/SiteLocaleSelectionPopupMenu';

export default function _SiteLocaleSelectionPopupMenu(props) {
    return <SiteLocaleSelectionPopupMenu {...props} />;
}
